import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import AutoCompleteField from '@components/common/form/AutoCompleteField';
import apiConfig from '@constants/apiConfig';
import {
    deviceKinds,
    tabletOrderQrCodeTypes,
} from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, BooleanField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Card, Col, Form, Row } from 'antd';

const message = defineMessages({
    objectName: 'Update Database',
});

const UpdateDatabaseForm = (props) => {
    const translate = useTranslate();
    const params = useParams();
    const kinhValues = translate.formatKeys(deviceKinds, [ 'label' ]);
    const subKindValues = translate.formatKeys(tabletOrderQrCodeTypes, [ 'label' ]);
    const [ deviceKind, setDeviceKind ] = useState();
    const queryParams = new URLSearchParams(location.search);
    const restaurantId = props.restaurantId || queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');
    const { formId, actions, dataDetail, onSubmit, setIsChangedFormValues, branchs, isEditing, cardProps } = props;
    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const handleSubmit = (values) => {
        const formattedValues = {
            ...values,
        };
        values.initialize = Number(values.initialize);
        return mixinFuncs.handleSubmit(formattedValues);
    };

    const randomString = (length = 4) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    useEffect(() => {
        if (isEditing) {
            form.setFieldsValue({
                ...dataDetail,
                serverProviderId: dataDetail?.serverProviderDto?.id,
            });
        } else {
            form.setFieldsValue({
                ...dataDetail,
                username: `user_${restaurantId}${randomString(5)}`,
                password: randomString(32),
                database: `db_${restaurantId}${randomString(5)}`,
                driverClassName: 'com.mysql.cj.jdbc.Driver',
                port: '3306',
                host: 'localhost',
                initialize: false,
            });
        }
    }, [ isEditing ]);
    return (
        <BaseForm id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange} size='100%'>
            <Card className="card-form" bordered={false} {...cardProps}>
                <Row gutter={16}>
                    <Col span={12}>
                        <AutoCompleteField
                            required
                            disabled={isEditing}
                            name="serverProviderId"
                            label={translate.formatMessage(commonMessage.serverProvider)}
                            apiConfig={apiConfig.serverProvider.autoComplete}
                            mappingOptions={(item) => ({ value: item.id, label: item.name })}
                            searchParams={(text) => ({ name: text })}
                            options={
                                isEditing && dataDetail?.serverProviderDto
                                    ? [
                                        {
                                            value: dataDetail.serverProviderDto.id,
                                            label: dataDetail.serverProviderDto.name,
                                        },
                                    ]
                                    : undefined
                            }
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            name="username"
                            label={<FormattedMessage defaultMessage="Username" />}
                            required
                            disabled
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            name="password"
                            label={<FormattedMessage defaultMessage="Password" />}
                            required
                            disabled
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            name="driverClassName"
                            label={<FormattedMessage defaultMessage="Driver Classname" />}
                            required
                            disabled
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            name="database"
                            label={<FormattedMessage defaultMessage="Database" />}
                            required
                            disabled
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            name="host"
                            label={<FormattedMessage defaultMessage="Host" />}
                            required
                            disabled={isEditing}
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            name="port"
                            label={<FormattedMessage defaultMessage="Port" />}
                            required
                            disabled={isEditing}
                        />
                    </Col>
                </Row>
                <Row gutter={16} align="middle">
                    <Col span={12}>
                        <TextField
                            name="maxConnection"
                            label={<FormattedMessage defaultMessage="Max Connection" />}
                            type="number"
                        />
                    </Col>
                    <Col span={4} style={{ marginTop: '20px' }}>
                        <BooleanField
                            label={<FormattedMessage defaultMessage="Initialize" />}
                            name="initialize"
                            onChange={(checked) => {
                                if (!checked) {
                                    form.setFieldsValue({ initialize: false });
                                }
                            }}
                        />
                    </Col>
                </Row>
                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default UpdateDatabaseForm;
